/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const ContactsUniquePage = () => {
  const { contactApi } = apiPath;
  const [uniqueData, uniqueLoading] = useFetch(contactApi);
  const [filteredData, setFilteredData] = useState();
  let { id } = useParams();

  useEffect(() => {
    setFilteredData(uniqueData?.filter((item) => item._id === id)[0]);
  }, [uniqueData, id]);

  if (uniqueLoading || !filteredData?._id) {
    return <Loading />;
  }

  const { country, address, _id } = filteredData ?? {};

  const data = [
    {
      elementType: "input",
      label: "country",
      type: "Text",
      name: "country",
      defaultValue: country,
      required: false,
    },
    {
      elementType: "textField",
      label: "address",
      type: "Text",
      name: "address",
      defaultValue: address,
      required: false,
    },
  ];

  const update = (data) => {
    data.slug = "ourOffices";
    updateData(contactApi, data, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default ContactsUniquePage;
